<template>
  <div>
    <div class="main-wrapper settings-page">
      <settings-sidebar-component v-if="!hideSidebar" />
      <div
        class="container-wrap"
        v-bind:style="[hideSidebar ? { 'padding-left': 0 } : {}]"
      >
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import SettingsSidebarComponent from "./components/SettingsSidebarComponent";

export default {
  name: "SettingsComponent",
  components: {
    SettingsSidebarComponent,
  },
  computed: {
    hideSidebar() {
      const isIntegrations = this.$route.query.isIntegrations;
      return isIntegrations || false;
    },
  },
  mounted() {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const redirectTo = params.get("redirectTo");
    const isXero = params.get("redirectToXero");
    const isQuickBooks = params.get("redirectToQuickBooks");
    const isIntegrations = this.$route.query.isIntegrations;

    if (redirectTo || isIntegrations || isXero || isQuickBooks) {
      document.body.classList.add("dashboard-new");
    }

    if (isXero || isQuickBooks) {
      document.body.classList.add("hide-dashboard-new-sidebar");
    } else {
      document.body.classList.remove("hide-dashboard-new-sidebar");
    }
  },
};
</script>

<style lang="scss">
.dashboard-new {
  .settings-sidebar.sidebar {
    height: 100vh !important;
    top: 0 !important;
    padding-left: 55px !important;
    padding-top: 55px;
  }
}
.check-wrapper {
  .custom-checkbox {
    margin-left: 2px;
    padding-left: 20px;

    .custom-control-label {
      padding-left: 18px;
      font-size: 1rem;
      font-family: "Roboto", sans-serif;
      line-height: 1.5rem;
      color: #262626;
      font-weight: 500;
      cursor: pointer;

      &::before {
        width: 20px;
        height: 20px;
        top: 2px;
        border: 1.5px solid #c7c7c7;
        left: -21px;
        border-radius: 3px;
      }

      &::after {
        content: "";
        width: 20px;
        height: 20px;
        font-size: 20px;
        top: 2px;
        left: -21px;

        /*  Atto Font Icon  */
        border-radius: 3px;
        font-family: "attotime" !important;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        color: #fff;
        transition: none;
      }
    }

    .custom-control-input:focus ~ .custom-control-label::before,
    .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
      box-shadow: none;
      border-color: #c7c7c7;
    }

    .custom-control-input:disabled ~ .custom-control-label {
      color: $atto-dark-grey;
    }

    .custom-control-input:disabled ~ .custom-control-label::before {
      border-color: $atto-light-grey;
    }

    .custom-control-input:checked:disabled ~ .custom-control-label::before {
      background-color: #fff;
      border-color: $atto-light-grey;
    }

    .custom-control-input:checked ~ .custom-control-label::before {
      background: transparent;
      border-color: #00b9cb;
    }

    .custom-control-input:checked ~ .custom-control-label::after {
      content: "\E98F";
      color: #00b9cb;
      background: none;
    }

    .custom-control-input:checked:disabled {
      ~ .custom-control-label {
        &::before {
          border-color: #efefef;
        }

        &::after {
          background-color: transparent;
          color: #efefef;
        }
      }
    }
  }

  .custom-radio {
    padding-left: 40px;

    .custom-control-label {
      font-size: 1rem;
      line-height: 1.5rem;
      cursor: pointer;

      &:focus {
        outline: 0;
      }
    }

    .custom-control-label::before {
      left: -40px;
    }

    .custom-control-label::after {
      left: -34px;
    }

    .custom-control-input:not(:disabled):active
      ~ .custom-control-label::before {
      background-color: #fff;
      border: 1.5px solid #c7c7c7;
    }
  }
}

h4.section-subtitle {
  font-size: 1.125rem;
  font-family: "Roboto", sans-serif;
  line-height: 2rem;
  color: #262626;
  font-weight: 500;
}

.settings-page {
  .white-card {
    height: auto;

    .content-wrapper {
      padding: 40px;
    }
  }
  .container-wrap {
    padding-top: 0;
    min-height: calc(100vh - 60px);

    .content {
      min-height: inherit;
      padding: 0 80px 70px;

      > .heading {
        padding: 24px 0;
        border-bottom: 2px solid $atto-light-grey;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        height: 90px;

        .page-title {
          font-size: 1.5rem;
          line-height: 2rem;
          font-family: $roboto-font;
          font-weight: 500;
          color: $atto-font-color;
        }

        &.no-border {
          border-bottom: 2px solid #fff;
        }

        button.atto-btn.submit.save-changes {
          width: 160px;
          text-transform: uppercase;
          font-weight: normal;

          &[disabled],
          &:disabled {
            color: $atto-not-active;
            background-color: $atto-light-grey;
            cursor: not-allowed;
          }
        }
      }

      &.manage {
        padding: 0;

        .heading {
          padding: 28px 80px 29px;
        }
      }

      .section-headtitle {
        font-size: 1.125rem;
        line-height: 2rem;
        font-family: $roboto-font;
        font-weight: 500;
        margin-bottom: 24px;

        &.disabled {
          color: $atto-dark-grey;
        }
      }
    }

    &.no-sidebar {
      padding-left: 0;
    }
  }
}

p.disclaimer {
  color: $atto-dark-grey;
  font-family: $roboto-font;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;
  display: inline-flex;
  padding-left: 40px;
  margin-bottom: 0;
  margin-top: 12px;
}

.toggle-dep {
  padding-top: 40px;
  padding-bottom: 40px;
  margin: 0 36px;

  p {
    color: $atto-dark-grey;
    font-family: $roboto-font;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.25rem;
    display: inline-flex;
    padding-left: 40px;
    margin-bottom: 0;
    margin-top: 12px;
  }

  &.bottom-border {
    border-bottom: 2px solid $atto-light-grey;
  }
}

.subsection {
  &.settings {
    .check-wrapper {
      margin-bottom: 32px;
    }
  }
}

.child-wrapper {
  padding-left: 40px;

  .field-wrap {
    display: flex;
    flex-direction: row;
    margin-bottom: 24px;
    align-items: center;

    p {
      margin-bottom: 0;
      width: 200px;
      font: $roboto-regular 0.875rem/1.75rem $roboto-font;
      color: $atto-font-color;
    }

    .atto-select {
      width: 184px;
    }

    input.timepicker {
      width: 80px;
    }
  }
}

/*    Settings List */

.settings-items-list {
  > li {
    > div,
    > a {
      display: flex;
      flex-direction: row;
      align-items: center;

      div.department-name {
        width: 390px;
        margin-right: 10px;

        h4.name {
          font-size: 1rem;
          line-height: 1.5rem;
          color: $atto-font-color;
        }
      }

      div.members {
        span.member-no {
          color: $atto-font-color;
          font-family: $roboto-font;
          font-size: 0.875rem;
          font-weight: 400;
          line-height: 1.5rem;
          display: inline-flex;
        }
        .atto-team {
          margin: 0 !important;
        }
      }

      .options {
        display: inline-flex;
        align-items: center;
        flex-direction: row;
        opacity: 1;
        margin-left: auto;
        @include base-transition(ease all 0.2s);

        .edit-btn,
        .delete-btn,
        .edit-member,
        .delete-member {
          display: flex;
          width: 40px;
          height: 40px;
          align-items: center;
          justify-content: center;
          text-align: center;
          background-color: transparent;
          border: 0;
          padding: 0;
          position: relative;

          i {
            position: absolute;
            display: inline-flex;
            width: 40px;
            height: 40px;
            font-size: 18px;
            text-align: center;
            align-items: center;
            justify-content: center;
            color: $atto-dark-grey;
            border-radius: 100%;
            @include base-transition(ease all 0.15s);

            &:before {
              @include base-transition(ease all 0.15s);
            }
          }

          &:hover:not(:disabled) {
            cursor: pointer;

            i {
              background-color: $atto-light-grey;

              /* &::before {
                                    color: $atto-font-color;
                                }*/
            }
          }

          &:disabled {
            cursor: not-allowed;
          }
        }
      }

      &:hover {
        background-color: $atto-grey;

        h4.name {
          color: $atto-font-color;
        }

        .options {
          .arrow,
          button {
            &:hover {
              color: $atto-font-color;
            }
          }
        }
      }
    }

    &:last-child {
      div,
      a {
        border-bottom: 0;
      }
    }
  }
}

.no-items {
  display: flex;
  /* height: 532px;*/
  height: 340px;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: #fff !important;
  }

  .item-wrap {
    width: 320px;
    text-align: center;
    display: flex;
    flex-flow: column;
    align-items: center;

    i {
      width: 86px;
      height: 88px;
      display: inline-flex;
      margin-bottom: 16px;
      background: url("~@assets/images/not-active.svg") no-repeat center;
      -webkit-background-size: contain;
      background-size: contain;

      &.departments {
        background-image: url("~@assets/images/no-department.svg");
      }

      &.no-job-codes {
        background-image: url("~@assets/images/no_job_codes-icon.svg");
      }
      &.no-members {
        width: 78px;
        height: 82px;
        background: url("~@assets/images/no_members_icon.svg") no-repeat center;
      }
      &.no-managers {
        width: 68px;
        height: 96px;
        background: url("~@assets/images/no_managers_icon.svg") no-repeat center;
      }
      &.no_time_off {
        width: 80px;
        height: 81px;
        background: url("~@assets/images/no_time_off.svg") no-repeat center;
      }
      &.no_job_sites {
        width: 75px;
        height: 88px;
        background: url("~@assets/images/no_job_sites.svg") no-repeat center;
      }
      &.no_departments {
        width: 82px;
        height: 98px;
        background: url("~@assets/images/no_departments.svg") no-repeat center;
      }
    }

    h4.subtitle {
      margin-bottom: 2px;
      font: $roboto-medium 1.25rem/1.75rem $roboto-font;
      color: $atto-font-color;
    }

    p {
      font: $roboto-regular 0.9375rem/1.5rem $roboto-font;
      color: #666666;
      margin: 0;
    }

    button.add-item {
      align-items: center;
      justify-content: center;
      font: $roboto-bold 1rem/1.1875rem $roboto-font;
      background-color: $atto-white;
      color: $atto-font-color;
      width: 200px;
      height: 40px;
      display: flex;
      cursor: pointer;
      border: 2px solid $atto-light-grey;
      margin-bottom: 12px;

      &:hover {
        border-color: $atto-font-color;
        background-color: $atto-font-color;
        color: $atto-white;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@media (max-width: 768px) {
  .settings-page {
    .container-wrap {
      padding-left: 0 !important;
    }
  }
}
</style>
